/**
 * Created by piotr.pozniak@thebeaverhead.com on 04/04/2024
 */

import React from "react";
import PropTypes from "prop-types";
import SharePopup from "../../../../WidgetsComponents/SharePopup";
import { useTranslation } from "react-i18next";
import { ShareIcon } from "../../../../consts";
import useCalendarPopupHook from "../../../../hooks/useCalendarPopupHook";
import { useCalendarStore } from "../../../../hooks/redux/calendar";

const ShareButton = ({ url, title, text }) => {
  const { onShow, showPopup, onClose } = useCalendarPopupHook();
  const { t } = useTranslation();
  const { calendar } = useCalendarStore();

  const sharePopup = showPopup ? (
    <SharePopup
      url={url}
      title={title}
      text={text}
      onClose={onClose}
      widgetSelectorID={`dce_calendar__${calendar.model.uuid}`}
    />
  ) : null;

  return (
    <>
      <a
        href={"#"}
        onClick={onShow}
        target={"_blank"}
        className={"share-event share-event--link"}
      >
        <i className="material-icons">{ShareIcon}</i> {t("Share")}
      </a>
      {sharePopup}
    </>
  );
};

ShareButton.defaultProps = {};

ShareButton.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
};

export default ShareButton;
